import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore' // Firestoreをインポート
import 'firebase/functions' // Cloud Functions用
import 'firebase/storage' // Storage用

// Firebase Hosting 配下以外では __/auth エンドポイントが存在せず 404 になるため、
// 認証ドメインを firebaseapp.com に固定する
const resolvedAuthDomain = 'open-hinata3.firebaseapp.com'

const firebaseConfig = {
  apiKey: 'AIzaSyD0br7P-RNCERYEO2pfnVJsQjstd-GztQY',
  authDomain: resolvedAuthDomain,
  projectId: 'open-hinata3',
  storageBucket: 'open-hinata3.firebasestorage.app',
  messagingSenderId: '531336516229',
  appId: '1:531336516229:web:1f41b71722d28ee51f4fec',
  measurementId: 'G-9WVN4ESGR2',
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export const auth = firebase.auth()
export const db = firebase.firestore() // Firestore用に変更

// Firestoreオフライン永続化を有効化（グループチャット等の高速化）
db.enablePersistence({ synchronizeTabs: true })
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // 複数タブが開いている場合（synchronizeTabsで対応済みだが念のため）
      console.warn('Firestore persistence: 複数タブで実行中')
    } else if (err.code === 'unimplemented') {
      // ブラウザが対応していない
      console.warn('Firestore persistence: このブラウザは非対応')
    }
  })
// Cloud Functions用 - Firebase Functions Gen2はus-central1で実行
// firebase.functions()を使用（v8 compat SDK）
const functionsInstance = firebase.functions()
functionsInstance.useEmulator && false // エミュレータは使わない
export const functions = functionsInstance
export const storage = firebase.storage()

export async function signIn(email, password) {
  try {
    const userCredential = await auth.signInWithEmailAndPassword(email, password)
    const idToken = await userCredential.user.getIdToken()
    const response = await fetch('/create-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ idToken }),
    })
    if (response.ok) {
    } else {
      console.error('セッション作成エラー')
    }
  } catch (error) {
    console.error('ログインエラー:', error.message)
    throw error
  }
}

export default firebase
